import React from 'react';

import {GameCompetitorViewModel} from "../../../../../../../domain/partial-game/models/game-competitor/game-competitor-view-model";
import {GameCenterHeaderModuleProps} from "../../../models/game-center-header-module.props";
import {EntityLogo, EntityLogoProps} from "../../../../../../../core/components/logos/entity-logo";
import {StarQualified} from "../../../../../../../core/icons/star-qualified";
import {BaseImage, BaseImageProps} from "../../../../../../../core/components/image/base-image";
import styles from "../../../styles/game-center-header-competitor.module.scss"
import {observer} from "mobx-react";
import classNames from "classnames";
import {GAME_CENTER_HEADER_MODULE} from "../../../game-center-header-module.consts";
import {GameCenterHeaderModuleDetailsCompetitorRanking} from "./game-center-header-module.details.competitor.ranking";

export class GameCenterHeaderDetailsCompetitorBadgeProps extends GameCenterHeaderModuleProps {
  isHomeTeam: Boolean;
  competitor: GameCompetitorViewModel;
}

export const GameCenterHeaderDetailsCompetitorBadge = observer(({controller, isHomeTeam}: GameCenterHeaderDetailsCompetitorBadgeProps) => {
  const {state} = controller;
  const {device: {isSmallView}} = state;

  const {
    homeCompetitor,
    awayCompetitor,
    homeCompetitorLogoAnimationClassName,
    awayCompetitorLogoAnimationClassName,
    animation,
    homeCompetitorEventLogoAnimationClassName,
    awayCompetitorEventLogoAnimationClassName,
    shouldRenderRanking
  } = state;

  const competitor = isHomeTeam ? homeCompetitor : awayCompetitor;

  const containerProps = {
    className: classNames(
      styles.competitor_flag,
      {[styles.home_competitor]: isHomeTeam},
      {[styles.away_competitor]: !isHomeTeam}
    )
  }

  const starQualifiedProps = {
    className: classNames(styles.star_qualified),
    width: GAME_CENTER_HEADER_MODULE.STAR_QUALIFIED_SIZE,
    height: GAME_CENTER_HEADER_MODULE.STAR_QUALIFIED_SIZE
  }

  const entityLogoProps: EntityLogoProps = {
    onLoad: () => controller.onRenderComplete(),
    entity: competitor,
    width: isSmallView ? GAME_CENTER_HEADER_MODULE.COMPETITOR_LOGO.mobile : GAME_CENTER_HEADER_MODULE.COMPETITOR_LOGO.desktop,
    height: isSmallView ? GAME_CENTER_HEADER_MODULE.COMPETITOR_LOGO.mobile : GAME_CENTER_HEADER_MODULE.COMPETITOR_LOGO.desktop,
    className: classNames(
      styles.logo,
      {[homeCompetitorLogoAnimationClassName] : isHomeTeam},
      {[awayCompetitorLogoAnimationClassName] : !isHomeTeam},
    )
  };

  const logoAnimationProps: BaseImageProps = {
    src: animation && animation.eventLogo,
    className: classNames(
      'hide',
      styles.event_logo,
      {[homeCompetitorEventLogoAnimationClassName]: isHomeTeam},
      {[awayCompetitorEventLogoAnimationClassName]: !isHomeTeam},
    ),
  };

  return (
    <div {...containerProps}>
      {
        competitor.isQualified && <StarQualified {...starQualifiedProps}/>
      }
      <EntityLogo {...entityLogoProps}/>
      {
        shouldRenderRanking ?<GameCenterHeaderModuleDetailsCompetitorRanking competitor={competitor}/> : null
      }
      <BaseImage {...logoAnimationProps} />
    </div>
  );
});